import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import Headerinner from "../layouts/Headerinner";
import Breadcrumbs from "../layouts/Breadcrumb";
import Footer from "../layouts/Footer";
import Content from "../sections/menu-v1/Content";
import services from "../../api/services";
import Preloader from "../layouts/Preloader";
import Headersticky from "../layouts/Headersticky";
import { checkBasket } from "../../utils/commons";
import { useDispatch } from "react-redux";
import {
	setApplication,
	setMenusAndProducts,
	setRestaurant,
} from "../../redux/reducers/restaurant";

const Menuone = () => {
	const [state, setState] = useState({
		isReady: false,
		restaurant: null,
		application: null,
		categories: [],
		allItems: [],
		totalPrice: [],
	});

	const dispatch = useDispatch();

	useEffect(() => {
		checkBasket();
		// Appel recuperer infos du restaurant
		const slug = window.location.host.split(".")[0];
		services.getAppInfo(
			slug,
			(res) => {
				let restaurant = res.restaurants[0];
				// console.log(res)
				try {
					restaurant.style = restaurant.style
						? JSON.parse("{" + restaurant.style.replace(/'/g, '"') + "}")
						: {};
					// const styles = `
					// 		.top-header{
					// 			background-color: ${restaurant.style.webheader} !important
					// 		}.btn-custom {
					// 			background-color: ${restaurant.style.webbtncustom} !important
					// 		}.btn-custom.light {
					// 			background-color: transparent !important;
					// 		}.ct-menu-categories {
					// 			background-color: ${restaurant.style.webcategories} !important
					// 		}.header-sticky .top-header {
					// 			background-color: ${restaurant.style.webheader} !important;
					// 			opacity: 0.9;
					// 		}.ct-footer {
					// 			background-color: ${restaurant.style.webfooter} !important
					// 		}`;

					// const styleSheet = document.createElement("style");
					// styleSheet.innerText = styles;
					// document.head.appendChild(styleSheet);

					window.loadRestaurant(restaurant);
				} catch (err) {
					restaurant.style = {};
				}

				localStorage.setItem("restaurant", JSON.stringify(restaurant));
				localStorage.setItem("application", JSON.stringify(res.application));

				dispatch(setRestaurant({ restaurant }));
				dispatch(setApplication({ application: res.application }));

				const application = res.application;

				// Your CSS as text
				services.getMenusAndProducts(
					restaurant.restaurantId,
					application.appId,
					(res) => {
						let allItems = res.results.menusWithCategories.concat(
							res.results.productsWithCategories
						);
						let allItemsGrouped = allItems.reduce((r, a) => {
							r[a.categoryName] = [...(r[a.categoryName] || []), a];
							return r;
						}, {});

						dispatch(
							setMenusAndProducts({
								products: res.results.productsWithCategories,
								optionLists: res.results.optionLists,
								menus: res.results.menusWithCategories,
							})
						);

						setState({
							...state,
							restaurant: restaurant,
							application,
							products: res.results.productsWithCategories,
							optionLists: res.results.optionLists,
							menus: res.results.menusWithCategories,
							allItems: allItems,
							allItemsByCategory: allItemsGrouped,
							categories: res.results.categories,
							selectedCategory: res.results.categories[0],
							isReady: true,
							loading: false,
							filter: res.results.categories[0].categoryName,
						});
					},
					(err) => {
						console.warn(err.status);
					}
				);
			},

			(err) => {
				console.error(err);
				window.location = "/error";
			}
		);
	}, []);

	return state.restaurant ? (
		<Fragment>
			<MetaTags>
				<title>{state.restaurant.name} | Commandez en ligne</title>
				<meta name="description" content="#" />
			</MetaTags>
			<Headerinner />

			<Headersticky />
			<Breadcrumbs
				breadcrumb={{
					pagename: state.restaurant.name,
				}}
			/>
			<Content
				categories={state.categories}
				allItemsByCategory={state.allItemsByCategory}
				allItems={state.allItems}
				optionLists={state.optionLists}
				colors={state.restaurant.style}
			/>
			<Footer
				footer={{
					style: "ct-footer footer-dark",
					logo: "assets/img/logo-light.png",
				}}
			/>
		</Fragment>
	) : (
		<Preloader />
	);
};

export default Menuone;
